import ForgotPW from './ForgotPW';
import Route from './route';

export default {
  RenderProp: ForgotPW,
  mainRoute: Route,
};
